/*
So the issue comes in that cache version (cv) get hardcoded at nuxt server startup,
using this function aligns client & server to use the same cv, with reasonable
3 minute cache time to the storyblok CDN.
see: https://www.storyblok.com/docs/concepts/caching
*/

export function useCachedStoryblok() {

	const fetchStory = async (urlPath, options) => {
		const queryParams = {
			path: urlPath,
			...options
		}
		const response = await $fetch.raw('/sblok', {
			ignoreResponseError: true,
			query: { path: urlPath, ...options },
		})
		return {
			data: response._data,
			total: Number(response.headers.get('total')) || 0,
			per_page: Number(response.headers.get('per-page')) || 0,
		}
	}

	const get = async (urlPath, options = {}, cacheKey = null) => {
		const res = await fetchStory(urlPath, options)
		return res
	}

	return {
		get,
		fetchStory
	}
}
